<template>
    <div class="height-percent-100 uk-position-relative">
        <div style="height:calc(100% - 30px)" v-if="carrierList.length">
            <div class="uk-flex uk-flex-between border row" v-for="row in carrierList" :key="row.id"
                style="white-space: nowrap;">
                <div class="uk-flex uk-flex-middle">
                    <i v-icon:theme="['carrierTypeConvert', row.typeId]"></i>
                    <i style="margin-right:5px" v-icon:theme="['carrierStatusConvert', row.status]"></i>
                    <i style="margin-right:5px" v-icon:theme="['isAbnormalConvert', row.abnormal]"></i>
                    <i style="margin-right:5px" v-icon:theme="['traceConvert', row.isTrace]"
                        :title="$t(traceConvert(row.isTrace).title)"></i>

                    <span>
                        <tooltip style="width: 120px;" :text="row.keycode">
                            <span>{{ row.keycode }}</span>
                        </tooltip>
                    </span>
                </div>
                <div>
                    <i class="el-icon-tickets cursor-pointer icon-margin" :title="$t('integration.details')"
                        @click="handleDetail(row)"></i>
                    <i class="el-icon-circle-close cursor-pointer" :title="$t('integration.remove')"
                        @click="handleDel(row)"> </i>
                </div>
            </div>
        </div>

        <div v-else style="height:calc(100% - 30px)">
            <el-empty :description="$t('integration.please_select_a_monitoring_point')"></el-empty>
        </div>

        <div>
            <el-button class="btn" @click="savePoint">{{ $t('integration.save_the_selected_monitoring_point') }}</el-button>
        </div>
    </div>
</template>

<script>
import bus from '@/utils/bus';
import { carrierTypeConvert, carrierStatusConvert, isAbnormalConvert, traceConvert } from '@/utils/convert';
import { analSavePoint } from '@/api/modules/monitorPoint';
import { carrierDetail } from '@/utils/winDetail';
import tooltip from '@/pages/system/resource/components/tooltip.vue';
export default {
    data() {
        return {
            carrierTypeConvert,
            carrierStatusConvert,
            isAbnormalConvert,
            traceConvert,
            carrierList: [],
            // carrierList的哈希表形式
            hashCarrierList: []
        };
    },
    components: {
        tooltip
    },
    methods: {
        handleDetail(row) {
            carrierDetail(row.id, row.keycode, row.typeId);
        },
        handleDel(row) {
            // 通知ChooseList删除列表 将对应的项目取消勾选
            bus.$emit('cancelSelect', row.id);
            // 在自己的列表删除
            this.carrierList = this.carrierList.filter(item => item.id !== row.id);
            this.sendCarrier();
        },
        savePoint() {
            const data = this.carrierList.map(item => item.id);
            analSavePoint(data).then(res => {
                if (res.result) {
                    this.$message.success($t($t('integration.saved_successfully')));
                    this.sendCarrier();
                }
            });
        },
        // 发送监测点到右边
        sendCarrier() {
            // if (this.carrierList.length) {
            bus.$emit('saveMonitorPoint', this.carrierList);

            //     //bus.$emit("reflashData",this.carrierList);
            // } else {
            //     // 事件绑定在LeftContent 因为Leftcontent才有完整的carrier列表 所以让其代发送监测点保存信号
            //     bus.$emit('sendCarrierList');
            // }
        }
    },
    mounted() {
        // 首次渲染标志 因为首次渲染时要将数据传送到右边
        let firstLoad = false;
        // 绑定事件接收数据
        bus.$on('selectRows', (rows, checked) => {
            this.carrierList = rows;
            this.sendCarrier();

            // if (firstLoad === false) {
            //     firstLoad = true;
            //     this.sendCarrier();
            // }
            // this.carrierList=this.carrierList.concat(rows.filter(item=>!hash[item.id]));
        });
    },
    beforeDestroy() {
        bus.$off('selectRows');
    }
};
</script>

<style lang="scss" scoped>
.device-list {
    height: 100%;
    width: 100%;
    padding: 1px;
    box-sizing: border-box;
    overflow: auto;

    i {
        cursor: pointer;
    }
}

// 隐藏table的横向滚动条
::v-deep .el-table__body-wrapper {
    overflow-x: hidden;
}

.btn {
    position: absolute;
    left: 2px;
    right: 2px;
    bottom: 3px;
}

.row {
    height: 30px;
    line-height: 30px;
    margin: 2px;
    padding: 0 2px;
}
</style>
